import commonGetter from '../getters/commonGetter'
import commonAction from '../actions/commonAction'
import commonMutation from '../mutations/commonMutation'

const commonModule = {
  state: {
    module: { path: 'index', titleEN: 'Welcome', titleCN: '欢迎' },
    courses: [],
    login: {},
    courseDetails: {},
    courseOpenJobs: [],
    certs: [],
    enterprise: {},
    employeeDegree: [],
    employeeTitle: [],
    certClass: [],
    certSubClass: [],
    jobs: [],
    learnDetails: [],
    learnApproveStep: [],
    learnPayMethod: [],
    makeUpPayMethod: [],
    makeUpDetails: [],
    makeUpApproveStep: [],
    news: [],
    newsDetails: {},
    newsSusplayer: {},
    newsTestPlans: {},
    courseRecommends: [],
    learnApproveCount1: 0,
    learnApproveCount2: 0,
    learnApproveCount3: 0,
    makeUpApproveCount1: 0,
    makeUpApproveCount2: 0,
    makeUpApproveCount3: 0,
    learningmgtDetails: {},
    commonJob: {},
    studyRecordDetails: {},
    invoiceApproveDetails: {},
    quickComments: [],
    weiXinTmpQrCode: {}
  },
  getters: commonGetter,
  actions: commonAction,
  mutations: commonMutation
};

export default commonModule;



// WEBPACK FOOTER //
// ./src/store/jzjy/modules/commonModule.js